module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sidebar', {
    attrs: {
      "enable": _vm.enableSidebar
    },
    model: {
      value: (_vm.sidebarStatus),
      callback: function($$v) {
        _vm.sidebarStatus = $$v
      },
      expression: "sidebarStatus"
    }
  }, [_c('div', {
    staticClass: "app-sidebar-content"
  }, [(_vm.title) ? _c('div', {
    staticClass: "app-sidebar-title",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeAndGo('/')
      }
    }
  }, [_c('span', {
    staticClass: "app-sidebar-title-left-icon"
  }, [(_vm.title.imageLeft) ? _c('img', {
    attrs: {
      "src": _vm.title.imageLeft,
      "alt": _vm.title.altLeft
    }
  }) : (_vm.title.svgLeft) ? _c('icon', {
    attrs: {
      "name": _vm.title.svgLeft
    }
  }) : (_vm.title.iconLeft) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.title.iconLeft))]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title.text))]), _vm._v(" "), _vm._t("logo", [_c('span', {
    staticClass: "app-sidebar-title-right-logo"
  }, [(_vm.title.imageRight) ? _c('img', {
    attrs: {
      "src": _vm.title.imageRight,
      "alt": _vm.title.altRight
    }
  }) : (_vm.title.svgRight) ? _c('icon', {
    attrs: {
      "name": _vm.title.svgRight
    }
  }) : (_vm.title.iconRight) ? _c('v-icon', [_vm._v(_vm._s(_vm.title.iconRight))]) : _vm._e()], 1)])], 2) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "app-sidebar-user"
  }, [_c('div', {
    staticClass: "user-avatar"
  }, [_c('v-icon', {
    staticClass: "user-avatar-icon",
    attrs: {
      "light": ""
    }
  }, [_vm._v("face")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_c('v-icon', [_vm._v("person")]), _vm._v(_vm._s(_vm.user.name))], 1), _vm._v(" "), _c('div', {
    staticClass: "user-location"
  }, [_c('v-icon', [_vm._v("room")]), _vm._v(_vm._s(_vm.user.location))], 1), _vm._v(" "), _c('div', {
    staticClass: "user-email"
  }, [_c('v-icon', [_vm._v("email")]), _vm._v(_vm._s(_vm.user.email))], 1)])]) : _vm._e(), _vm._v(" "), (_vm.blocks) ? _c('div', {
    staticClass: "app-sidebar-blocks"
  }, [_c('v-list', _vm._l((_vm.blocks), function(item, index) {
    return _c('v-list-group', {
      key: item.title,
      attrs: {
        "value": item.active
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item"
      },
      slot: "item"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.label))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _vm._l((item.lists), function(subItem) {
      return _c('v-list-tile', {
        key: subItem.label,
        on: {
          "click": function($event) {
            _vm.closeAndGo(subItem.link)
          }
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
        class: {
          'active': _vm.fullPath === subItem.link
        }
      }, [_vm._v(_vm._s(subItem.label))])], 1)], 1)
    })], 2)
  }))], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f08d246","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/components/AppSidebar.vue
// module id = 578
// module chunks = 6